import React from 'react';

import type { IconComponentFunction } from '@motorway/mw-highway-code';
import { Icon } from '@motorway/mw-highway-code';

import { ReactComponent as IconComponent } from '../../../../client/assets_seller/serviceFees/payment-sent.svg';

export const PaymentSentIcon: IconComponentFunction = (props) => (
  <Icon {...props}>
    <IconComponent />
  </Icon>
);
